import React, { useState, useEffect } from "react";
import { BASE_URL } from "../Config";
import MainLayout from "../components/MainLayout/MainLayout";
import "./pages.css";
import { toast } from "react-toastify";

const BulkMarketing = () => {
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [templateDetails, setTemplateDetails] = useState(null);
  const [base64Image, setBase64Image] = useState('');
  const [variables, setVariables] = useState({});
  const [memberGroup, setMemberGroup] = useState([]);
  const [selectedMemberGroup, setSelectedMemberGroup] = useState("");
  const [image, setImage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [tempResponse, memberGroupResponse] = await Promise.all([
          fetch(`${BASE_URL}/api/template`, {
            method: "GET",
            headers: {
              wabaId: localStorage.getItem("WabaId"),
              phoneNumberId: localStorage.getItem("ClientPhoneNumberId"),
            },
          }),
          fetch(`${BASE_URL}/api/members/memberGroup`, {
            method: "GET",
            headers: {
              wabaId: localStorage.getItem("WabaId"),
              phoneNumberId: localStorage.getItem("ClientPhoneNumberId"),
            },
          }),
        ]);

        if (!tempResponse.ok || !memberGroupResponse.ok) {
          throw new Error("Failed to fetch data.");
        }

        const tempData = await tempResponse.json();
        const approvedTemplates = tempData.data.filter(
          (template) => template.status === "APPROVED"
        );
        setTemplates(approvedTemplates);

        const memberGroupData = await memberGroupResponse.json();
        setMemberGroup(memberGroupData);

        setError(null);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.message);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchTemplateDetails = async () => {
      if (!selectedTemplate) return;

      try {
        const response = await fetch(
          `${BASE_URL}/api/template/getTemplateById/${selectedTemplate}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              wabaId: localStorage.getItem("WabaId"),
              phoneNumberId: localStorage.getItem("ClientPhoneNumberId"),
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Failed to fetch template details.`);
        }

        const data = await response.json();
        setTemplateDetails(data);

        const vars = {};
        data?.components
          ?.find((comp) => comp.type === "BODY")
          ?.example?.body_text?.[0]?.forEach((_, index) => {
            vars[`var${index + 1}`] = "";
          });
        setVariables(vars);
      } catch (error) {
        console.error("Error fetching template details:", error);
        setTemplateDetails(null);
        toast.error(error.message);
      }
    };

    fetchTemplateDetails();
  }, [selectedTemplate]);

  const handleTemplateChange = (newTemplateId) => {
    setSelectedTemplate(newTemplateId);
    setTemplateDetails(null);
    setVariables({});
    setImage(null);
    setBase64Image('');
  };

  const handleVariableChange = (key, value) => {
    setVariables({ ...variables, [key]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      setBase64Image(reader.result.split(',')[1]);
    };
    reader.readAsDataURL(file);
  };

  const handleSendMessages = async () => {
    if (!selectedTemplate || !selectedMemberGroup) {
      toast.error("Please select a template and member group.");
      return;
    }

    const missingVariable = Object.keys(variables).some(
      (key) => variables[key].trim() === ""
    );
    if (missingVariable) {
      toast.error("Please fill all template variables.");
      return;
    }

    const requiresImage =
      templateDetails &&
      templateDetails.components.some(
        (comp) => comp.type === "HEADER" && comp.format === "IMAGE"
      );
    if (requiresImage && !image) {
      toast.error("Please upload an image as required by the template.");
      return;
    }

    let selectedTemplateName;
    for (let i = 0; i < templates.length; i++) {
      if (templates[i].id === selectedTemplate) {
        selectedTemplateName = templates[i].name;
      }
    }

    const formData = new FormData();
    formData.append("templateId", selectedTemplateName);
    formData.append("variables", JSON.stringify(variables));
    formData.append("selectedMemberGroup", selectedMemberGroup);
    if (image) {
      formData.append("image", image);
    }

    try {
      const response = await fetch(`${BASE_URL}/api/message/sendBulkMessages`, {
        method: "POST",
        headers: {
          wabaId: localStorage.getItem("WabaId"),
          phoneNumberId: localStorage.getItem("ClientPhoneNumberId"),
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to send messages.");
      }

      toast.success("Messages sent successfully.");
    } catch (err) {
      console.error("Error sending messages:", err);
      toast.error(err.message);
    }
  };


  return (
    <MainLayout>
      <div className="body" style={{ padding: "20px", marginTop: "-19px" }}>
        <h2>Campaign</h2>
        <div style={{ display: 'flex', gap: '35px', width: '98%', marginTop: '-33px' }}>
          <div style={{ width: '70%' }} className="formStyle">
            {error && <p className="error-message">Error: {error}</p>}

            <div className="form-group">
              <label>Select Template:</label>
              <select
                onChange={(e) => handleTemplateChange(e.target.value)}
                value={selectedTemplate}
                className="formInput"
              >
                <option value="">Select Template</option>
                {templates.map((template) => (
                  <option key={template.id} value={template.id}>
                    {template.name}
                  </option>
                ))}
              </select>
            </div>

            {templateDetails && (
              <>
                {templateDetails.components.some(
                  (comp) => comp.type === "HEADER" && comp.format === "IMAGE"
                ) && (
                    <div className="form-group">
                      <label>Upload Image:</label>
                      <input type="file" style={{ width: '93%' }} className="formInput" onChange={handleImageChange} />

                    </div>
                  )}

                <h4>Fill Template Variables:</h4>
                {Object.keys(variables).map((key, index) => (
                  <div key={key} className="form-group">
                    <label>{`Variable ${index + 1}`}</label>
                    <input
                      type="text"
                      style={{ width: '93%' }}
                      value={variables[key]}
                      onChange={(e) => handleVariableChange(key, e.target.value)}
                      className="formInput"
                    />
                  </div>
                ))}
              </>
            )}

            <div className="form-group">
              <label>Select Member Group:</label>
              <select
                onChange={(e) => setSelectedMemberGroup(e.target.value)}
                value={selectedMemberGroup}
                className="formInput"
              >
                <option value="">Select Group</option>
                {memberGroup.map((group) => (
                  <option key={group._id} value={group._id}>
                    {group.memberGroup}
                  </option>
                ))}
              </select>
            </div>

            <button onClick={handleSendMessages} className="submitButton">
              Send Messages
            </button>
          </div>
          <div style={{ marginTop: '20px' }}>
            <h2>Your template preview in chat</h2>
            <div style={styles.chatContainer}>
              <div style={styles.messageBubble}>
                {templateDetails &&
                  templateDetails.components &&
                  templateDetails.components.some(
                    (comp) => comp.type === 'HEADER' && comp.format === 'IMAGE'
                  ) &&
                  image && (
                    <img
                      src={URL.createObjectURL(image)}
                      alt="Media Preview"
                      style={styles.messageImage}
                    />
                  )}

                {templateDetails &&
                  templateDetails.components &&
                  templateDetails.components.some((comp) => comp.type === 'BODY') ? (
                  <p style={styles.messageText}>
                    {
                      templateDetails.components.find((comp) => comp.type === 'BODY')
                        .text.replace(/{{(\d+)}}/g, (_, index) =>
                          variables[`var${index}`] || `{{${index}}}`
                        )
                    }
                  </p>
                ) : (
                  <p style={styles.messageText}>Your preview will appear here.</p>
                )}
                <span style={styles.messageTime}>18:57</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </MainLayout>
  );
};

const styles = {
  chatContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '10px',
    backgroundColor: '#eae6df',
    borderRadius: '10px',
    width: '100%',
    maxWidth: '400px',
    margin: '20px auto',
  },
  messageBubble: {
    backgroundColor: '#fff',
    borderRadius: '10px',
    padding: '10px',
    boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.1)',
    maxWidth: '80%',
    position: 'relative',
  },
  messageImage: {
    width: '100%',
    borderRadius: '5px',
    marginBottom: '10px',
  },
  messageText: {
    margin: 0,
    fontSize: '14px',
    color: '#000',
  },
  messageTime: {
    position: 'absolute',
    bottom: '5px',
    right: '10px',
    fontSize: '12px',
    color: '#999',
  },
};


export default BulkMarketing;
